module.exports = __webpack_public_path__ + "static/sydney-4312687cf528c3a46de21916da038bf2.png";